'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delete = require('unmutable/lib/delete');

var _delete2 = _interopRequireDefault(_delete);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipe = require('unmutable/lib/util/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key) {
    var fn = (0, _delete2.default)(key);
    return (0, _pipe2.default)((0, _update2.default)('value', fn), (0, _update2.default)('child', fn));
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/delete.js
// module id = 746
// module chunks = 35783957827783